import {Directive, ElementRef, inject, input, OnInit} from '@angular/core';
import {UserFormFactory} from '../services/user-form.factory';
/**
 * דירקטיב שאוסף את כל האלמנטים עם אטריבוט formControlName
 * לשימוש בכל אלמנט שנתמך על ידי formControlName
 *
 * דוגמא לשימוש:
 * <input formControlName="username" dcFormControlCollector sectionId="general-details" />
 */
@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[formControlName]',
})
export class FormControlCollectorDirective implements OnInit {
	public readonly elementRef = inject(ElementRef);
	public readonly formControlName = input.required<string>();

	public readonly userFormFactory = inject(UserFormFactory);

	ngOnInit(): void {
		const el = this.elementRef.nativeElement;
		const formControlName = this.formControlName();
		if (el && formControlName) {
			this.userFormFactory.registerFormControl(formControlName, el);
		}
	}
}
